"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "recursiveCTEFromLookupColumn", {
    enumerable: true,
    get: function() {
        return recursiveCTEFromLookupColumn;
    }
});
async function recursiveCTEFromLookupColumn(_param) {
    return (_qb)=>{};
}
